<template>
    <div>
        <GridPage
            ref="gridPage"
            :form-default="{
                user_item_caches_id: [],
                user_item_caches: {},
                margin: 0,
                status: 'suspended',
                details: {
                    amazon: {
                        shipping_speed_category: 'Standard',
                    },
                },
            }"
            :filters-default="{
                status: '',
                sort: 'name',
            }"
            :filter-items="[
                {
                    vModel: 'status',
                    title: '同期',
                    options: [
                        { text: '全て', value: '' },
                        { text: '同期ON', value: 'activated' },
                        { text: '同期OFF', value: 'suspended' },
                    ],
                },
            ]"
            filters-q-placeholder="名前"
            form-modal-id="item"
            search-action="item/index"
            row-class="flex-nowrap mx-0 my--2"
            >
            <template v-slot:form="{ form, init }">
                <Item :model="form" :init="init" @save="$refs.gridPage.save" @destroy="$refs.gridPage.destroy"></Item>
            </template>

            <template v-slot:column="{ item }">
                <div class="d-flex w-100">
                    <div class="align-self-center flex-shrink-1">
                        <b-form-checkbox
                            v-model="item.checked"
                            :value="true"
                            :unchecked-value="false"
                            >
                        </b-form-checkbox>
                    </div>
                    <div class="flex-grow-1">
                        <div class="d-flex flex-nowrap bd-highlight">
                            <div class="p-2 flex-shrink-1 bd-highlight">
                                <ItemThumb :model="item" class="mb-1" />
                            </div>
                            <div class="p-2 flex-grow-1 bd-highlight d-flex">
                                <b-row class="no-gutters w-100">
                                    <b-col md="6" class="align-self-center">
                    <!--
                    -->
                                        <ItemBadges :model="item" class="mb-1" />
                                        <p class="mb-1 font-weight-bold">
                                            {{ (item.user_item_caches.amazon ? item.user_item_caches.amazon.name : '') || (item.user_item_caches.ebay ? item.user_item_caches.ebay.name : '') }}
                                        </p>
                    
                                    </b-col>
                                    <b-col md="6" class="align-self-center">
                                        <div class="mb-1">
                                            <table class="table table-bordered mb-0 lh-1">
                                                <tbody>
                                                    <b-tr class="table-light">
                                                        <td class="text-center w-50 p-1">
                                                            <small><strong>Amazon</strong></small>
                                                            <br>
                                                            <small v-if="item.user_item_caches.amazon">
                                                                x{{ item.user_item_caches.amazon.quantity }}
                                                            </small>
                                                        </td>
                                                        <td class="text-center w-50 p-1">
                                                            <small><strong>eBay</strong></small>
                                                            <br>
                                                            <small v-if="item.user_item_caches.ebay">
                                                                x{{ item.user_item_caches.ebay.quantity }}
                                                            </small>
                                                            <small v-else>
                                                                <a href="#" @click="listItem(item, 'ebay')">出品登録</a>
                                                            </small>
                                                        </td>
                                                    </b-tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </b-col>
                                </b-row>
        
                            </div>
                        </div>
                    </div>
    <!--
                    <div class="align-self-center flex-shrink-1">
                        <b-form-checkbox v-model="item.synced" switch @change="onChange">
                        </b-form-checkbox>
                    </div>
    -->
                </div>
            </template>
        </GridPage>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import GridPage from '@/components/GridPage.vue'
import Item from '@/components/Item.vue'
import ItemBadges from '@/components/ItemBadges.vue'
import ItemThumb from '@/components/ItemThumb.vue'
import FormDate from '@/components/FormDate.vue'
import ItemInfo from '@/components/ItemInfo.vue'

export default {
    components: {
        GridPage,
        Item,
        ItemBadges,
        ItemThumb,
        FormDate,
        ItemInfo,
    },
    computed: {
        ...mapGetters([
            'auth_level',
            'auth_name',
            'auth_uuid',
            'trans',
        ])
    },
    data() {
        return {}
    },
    methods: {
        async listItem(item, provider) {
console.log(item)
console.log(provider)
            let provider_type = null
            switch (provider) {
                case 'amazon':
                    provider_type = 'inventory'
                    break
                case 'ebay':
                    provider_type = 'store'
                    break
            }

            await this.$store
                .dispatch('store/list_item', { uuid: provider, })
                .then((response) => {
//                    this.fetch()
                    this.$emit('sync')
                })
                .catch((error) => {
                })
        },
    },
}
</script>

